// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CourseRegistrationInputs
{
    width: 80%;
    height: auto;
    margin-left: 10%;
    
}
.RegisterInCourseFeeTextField

{
    padding: 1%;

}
.RegisterButtonDiv
{
    display: flex;
    align-items: center;
    justify-content: center;
    
}
.RegisterButton 
{
    padding:  1% 1% 1% 1% ;
    border: 0;
    
    border-radius: 1vh;
    background-color: #03b4c6;
    color: white;
    font-size: 3vh;
}`, "",{"version":3,"sources":["webpack://./src/MyComponents/AdminActions/AdminRegisterInCourse.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,YAAY;IACZ,gBAAgB;;AAEpB;AACA;;;IAGI,WAAW;;AAEf;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;AACA;;IAEI,sBAAsB;IACtB,SAAS;;IAET,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB","sourcesContent":[".CourseRegistrationInputs\n{\n    width: 80%;\n    height: auto;\n    margin-left: 10%;\n    \n}\n.RegisterInCourseFeeTextField\n\n{\n    padding: 1%;\n\n}\n.RegisterButtonDiv\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n}\n.RegisterButton \n{\n    padding:  1% 1% 1% 1% ;\n    border: 0;\n    \n    border-radius: 1vh;\n    background-color: #03b4c6;\n    color: white;\n    font-size: 3vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
